import flatpickr from "flatpickr"
import { French } from "flatpickr/dist/l10n/fr.js"
import "flatpickr/dist/flatpickr.min.css"
import { triggerBackofficeAutosave, syncPricingChecklistFromField } from "packs/init-backoffice-autosave"

const MODES = {
  date: {
    dateFormat: "Y-m-d",
    altFormat: "d/m/Y",
  },
  datetime: {
    enableTime: true,
    time_24hr: true,
    dateFormat: "Y-m-d H:i",
    altFormat: "d/m/Y à H:i",
  },
  time: {
    enableTime: true,
    noCalendar: true,
    time_24hr: true,
    dateFormat: "H:i",
    altFormat: "H:i",
  },
}

const syncOptionalScheduleNote = (form) => {
  if (!form) return
  const note = form.querySelector("[data-optional-schedule-note]")
  if (!note) return

  const fields = form.querySelectorAll("[data-optional-schedule-field]")
  if (!fields.length) return

  const complete = Array.from(fields).every((field) => field.value.trim() !== "")
  note.hidden = complete
}

export const initBackofficeFlatpickr = () => {
  document.querySelectorAll("[data-flatpickr]").forEach((el) => {
    if (el._flatpickr) return

    const config = MODES[el.dataset.flatpickr]
    if (!config) return

    flatpickr(el, {
      locale: French,
      altInput: true,
      altInputClass: el.className || "backoffice-input",
      allowInput: true,
      onChange: () => {
        const form = el.closest("form[data-autosave]")
        if (form) {
          syncOptionalScheduleNote(form)
          syncPricingChecklistFromField(el)
          triggerBackofficeAutosave(form)
        }
      },
      ...config,
    })
  })
}

document.addEventListener("turbolinks:before-cache", () => {
  document.querySelectorAll("[data-flatpickr]").forEach((el) => {
    if (el._flatpickr) el._flatpickr.destroy()
  })
})
